<template>
    <div style="width: 100%;">
        <div class="d-flex col-12">
            <div class="form-control-label" style="white-space: pre-line;">{{title}}</div>
        </div>
        <div class="col-12" style="margin-top: 1em;" v-if="question.image_file_name">
            <img class="cursor-pointer" :src="this.context.storageEndpoint + this.question.image_file_name" @click="openPhotoViewer = true"/>
        </div>
        <div class="col-12"><p class="form-control-label mt-2 question-description" v-html="formattedText"></p></div>
        <photo-viewer
            v-if="openPhotoViewer"
            ref="photoViewer"
            :photos="photo"
            :context="context"
            @close="openPhotoViewer = false"></photo-viewer>
    </div>
</template>

<script>
import Constants from '../../constants';
import PhotoViewer from '../common/PhotoViewer.vue';

export default {
    components: { PhotoViewer },
    props: ['question', 'providerId', 'context', 'answer'],
    data() {
        return {
            id: this.question.id,
            content: this.question.content,
            status: this.question.status,
            adminQuestion: this.question.question,
            Constants,
            showInvalid: false,
            openPhotoViewer: false
        };
    },

    computed: {
        title: function() {
            return this.content.meta.title || '';
        },

        photo() {
            if (this.question.image_file_name) {
                return [{
                    path: this.question.image_file_name
                }];
            } else {
                return [];
            }
        },

        hasAnswer() {
            return false;
        },

        hasValidAnswer() {
            return true;
        },
        formattedText() {
            const text = this.content.text;
            return text.nl2brIfNotHTML();
        }
    },

    methods: {
        onAnswerChange(newAnswer) {
            this.answer = newAnswer;
        },

        highlightInvalidState() {
            this.showInvalid = true;
        },

        getDataToPersist() {
            return {
                question_id: this.id,
                answer: '',
                answer_id: this.answer ? this.answer.id : null
            };
        }
    }
}
</script>

<style scoped>
.question {
  cursor: pointer;
  margin-bottom: 0.3em;
}
.question-type {
  font-size: 0.8em;
  color: #aaa;
  line-height: 1.2em;
  margin-top: 0.2em;
}
img {
    max-width: max-content;
    width: 100%;
    border-radius: 4px;
}
</style>
